import request from '@/utils/request'
import qs from 'qs'

export function getListMaintainJobDashboardApi(query) {
  return request({
    url: '/chamber-service/v1/room-require/list',
    method: 'get',
    params: query,
    paramsSerializer: query => qs.stringify(query, { arrayFormat: 'repeat' })
  })
}

export function addNewMaintainJobDashboardApi(query) {
  return request({
    url: '/chamber-service/v1/room-require',
    method: 'post',
    data: query
  })
}

export function updateMaintainJobDashboardApi(query) {
  return request({
    url: '/chamber-service/v1/room-require',
    method: 'put',
    data: query
  })
}

export function deleteMaintainJobDashboardApi(query) {
  return request({
    url: '/chamber-service/v1/room-require',
    method: 'delete',
    data: query
  })
}
